import PropTypes from 'prop-types';
import modal from '~/js/modules/magnific-popup';
import GoFetch from '~/js/modules/fetchling';

const fetch = new GoFetch();

export default class ItemCard extends React.Component {
  static propTypes = {
    itemData: PropTypes.object,
    isGrid: PropTypes.bool,
    categoryId: PropTypes.number,
    userInfo: PropTypes.object,
    userId: PropTypes.number,
    isGridOnSlider: PropTypes.bool,
    modalUpdateHandler: PropTypes.func,
    isSuccessAddedHandler: PropTypes.func,
  };
  static defaultProps = {
    isGrid: false,
    isGridOnSlider: false,
    categoryId: null,
    itemData: {},
    userInfo: {},
    modalUpdateHandler: () => null,
    isSuccessAddedHandler: () => null,
  };
  constructor(props) {
    super(props);
    this.state = {
      itemDetails: {},
      accountInfo: {}
    };
  }
  componentDidMount() {
    // modal();
    // $('.mfp-close').on('click', () => {
    //     $('body').removeClass('no-flow');
    // });
  }
  _priceToRender = (priceRange) => {
    if (priceRange === '$CFP') {
      return <big className="call-for-pricing">Call for pricing<small>1-877-SANDALS</small></big>;
    }
    if (priceRange === '$0') {
      return <big className="item-price free">free</big>;
    }

    return <big className="item-price">{ priceRange }</big>;
  };

  _fetchItemDetails = (attributeId) => {
    const userId = this.props.userId ? this.props.userId : null;
    const requestBody = { attributeId: attributeId, userId };
    const itemContent = document.querySelector('.item-details');

    $.magnificPopup.close();
    $.magnificPopup.open({
      items: {
        src: '#item-modal',
        type: 'inline'
      }
    });
    $('.mfp-close').empty();
    $('.sk-loader-item').show();
    itemContent.classList.add('hide');
    fetch.post('/weddingStyler/item/details/', null, requestBody)
      .then(response => {
        this._setDefaultDetails(response.data.itemDetails, attributeId);
      })
      .then(() => itemContent.classList.remove('hide'))
      .then(() => $('.sk-loader-item').hide())
      .catch((err) => console.warn(err));
  };
  _setDefaultDetails = (itemData, attributeId) => {
    itemData.currentAttributeId = attributeId;
    itemData.price = itemData.price ? itemData.price : 0;
    itemData.destinationPrice = '';
    itemData.currentRegionId = itemData.priceList[0].region.id;
    $('#dropdown-price').val(itemData.priceList[0].region.id);
    itemData.hiddenPriceFlag = itemData.priceList[0].hiddenPrice;
    itemData.quantity = 1;

    $('#quantity').val(`${itemData.quantity}`);
    this.props.modalUpdateHandler(itemData);
    this.props.isSuccessAddedHandler(false);
    this.setState({itemDetails: itemData});
  };

  render() {
    const { itemData, isGrid, isGridOnSlider } = this.props;
    const cdnPath = '//cdn.sandals.com/sandals';
    const image = (itemData.imagePath) ? itemData.imagePath : '/wedding-styler/small/no-img.jpg';
    const price = itemData.priceRange ? itemData.priceRange : itemData.price;
    const priceRange = this._priceToRender(price);
    const nameLength = itemData.name ? itemData.name.length : itemData.itemName.length;
    let nameLines = '';

    if (nameLength <= 28) {
      nameLines = 'one-line-title';
    } else if (nameLength > 28 && nameLength <= 49) {
      nameLines = 'two-line-title';
    } else if (nameLength >= 50) {
      nameLines = 'three-line-title';
    }

    return (
      <div className={`${isGrid && 'xs-6 lg-4 xl-3'} ${isGridOnSlider && 'xs-6 lg-4'} item-card `}>
        <div className="sub-container">
          <span className="sub-category">{ itemData.subcategoryName || itemData.subCategoryName }</span>
        </div>
        <div className="green-wrapper pr">
          <img className="img-responsive use-attributes" src={`${cdnPath}${image}`} alt=""/>
          <span className="item-in-wishlist">{ itemData.wishListNote || itemData.wishlistNote }</span>
        </div>
        <div className="card-copy txt-center">
          <h5 className={`item-name ${nameLines}`}>{ itemData.name || itemData.itemName }</h5>
          { priceRange }
          <button className="item-details-link"
            onClick={ () => this._fetchItemDetails(itemData.attributeId || itemData.itemAttributeId) }
          >Details
          </button>
        </div>
      </div>
    );
  }
}
